import { render, staticRenderFns } from "./KufForm.vue?vue&type=template&id=31430874&"
import script from "./KufForm.vue?vue&type=script&lang=js&"
export * from "./KufForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports